import OverflowPillList from "components/OverflowPillList";
import { arrayOf, shape, string } from "prop-types";
import { useMemo } from "react";

const TagsCell = ({ tags = [] }) => {
  const items = useMemo(
    () => tags.map((tag) => ({ id: tag.termGuid, label: tag.label })),
    [tags]
  );

  if (items.length === 0) {
    return null;
  }

  return <OverflowPillList items={items} />;
};

TagsCell.propTypes = {
  tags: arrayOf(
    shape({
      level: string,
      termGuid: string,
      label: string,
    })
  ),
};

export default TagsCell;
